// extracted by mini-css-extract-plugin
module.exports = {"title":"RemindPassword_title__AZzyn","tabsContainer":"RemindPassword_tabsContainer__SBPUf"};